import { z } from 'zod';

export const bulkOperationTypeEnum = z.enum(['enable', 'disable', 'delete']);

export const bulkOperationRequestSchema = z.object({
  operation: bulkOperationTypeEnum,
  ids: z.array(z.string().uuid()).min(1).max(50),
});

export const bulkOperationResultSchema = z.object({
  results: z.array(z.object({
    id: z.string().uuid(),
    status: z.enum(['success', 'failed']),
    error: z.string().optional(),
  })),
  successCount: z.number(),
  errorCount: z.number(),
});

export const exportIntegrationsRequestSchema = z.object({
  ids: z.array(z.string().uuid()).min(1).max(50),
  format: z.enum(['json']).default('json'),
  includeSecrets: z.boolean().default(false),
});

export const exportIntegrationsResponseSchema = z.object({
  data: z.string(),
  filename: z.string(),
  contentType: z.string(),
});

export const importIntegrationRequestSchema = z.object({
  data: z.record(z.string(), z.unknown()),
  conflictMode: z.enum(['error', 'rename']).default('error'),
});

export const cloneIntegrationRequestSchema = z.object({
  name: z.string().min(3).max(255),
  description: z.string().optional(),
});
